import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControlLabel,
    Radio,
    RadioGroup,
    Stack,
    Typography
} from "@mui/material";
import {
    APPEARANCE_OPTIONS,
    useAppearance
} from "../../shared/AppearanceProvider";
import IconBadge from "../icon-badge/IconBadge";

export default function AppearanceDialog({open, onClose}) {
    const {preference, setPreference} = useAppearance();
    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="xs"
            aria-labelledby="appearance-title"
        >
            <DialogTitle id="appearance-title">Aparência</DialogTitle>
            <DialogContent>
                <RadioGroup
                    aria-label="Tema da interface"
                    value={preference}
                    onChange={(event) => setPreference(event.target.value)}
                >
                    {APPEARANCE_OPTIONS.map(({value, label, icon}) => (
                        <FormControlLabel
                            key={value}
                            value={value}
                            control={<Radio />}
                            sx={{minHeight: 48}}
                            label={
                                <Stack
                                    direction="row"
                                    spacing={1.5}
                                    alignItems="center"
                                >
                                    <IconBadge size={36}>{icon}</IconBadge>
                                    <span>{label}</span>
                                </Stack>
                            }
                        />
                    ))}
                </RadioGroup>
                <Typography variant="body2" color="text.secondary" sx={{mt: 1}}>
                    Automático acompanha a preferência do dispositivo. A escolha
                    é salva neste navegador.
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Fechar</Button>
            </DialogActions>
        </Dialog>
    );
}
